import { FC, ReactElement, memo, useState } from 'react';

import { useAppPagination } from '@/common/hooks';
import { FallbackedLayout } from '@/common/layouts';

import { CloudflareAccountsSearchingForm, useGetAllCloudflareAccountsQuery } from '@/modules/DomainsApi';

import { CloudflareAccountsListView } from './CloudflareAccountsListView';

export const CloudflareAccountsListContainer: FC = memo(() => {
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const {
    data: cloudflareAccountsListData,
    error: cloudflareAccountsListError,
    isLoading: isCloudflareAccountsListLoading,
    isFetching: isCloudflareAccountsListFetching,
    isError: isCloudflareAccountsListError
  } = useGetAllCloudflareAccountsQuery({ page: currentPage }, search)();

  return (
    <FallbackedLayout
      isLoading={ isCloudflareAccountsListLoading }
      error={ cloudflareAccountsListError }
      isError={ isCloudflareAccountsListError }
      data={ cloudflareAccountsListData }
    >
      { (cloudflareAccountsList): ReactElement => (
        <>
          <CloudflareAccountsSearchingForm search={ search } handleSubmitSearch={ setSearch }/>
          <CloudflareAccountsListView
            currentPage={ currentPage }
            cloudflareAccountsListItems={ cloudflareAccountsList.items }
            cloudflareAccountsListTotalItems={ cloudflareAccountsList.meta.totalItems }
            cloudflareAccountsListItemsPerPage={ cloudflareAccountsList.meta.itemsPerPage }
            isLoading={ isCloudflareAccountsListFetching }
            handleChangePage={ handleChangePage }
          />
        </>
      ) }
    </FallbackedLayout>
  );
});
